import React, { useState } from 'react';

const Bookus = () => {
  const [state, setState] = useState({
    date: '',
    time: '',
    number_of_people: 0,
    email: '',
    notes: ''
  });

  const handleChange = (event: any) => {
    event.preventDefault();
    setState({ ...state, [event.target.name]: event.target.value });
  }

  const handleSubmit = async (event: any) => {
    event.preventDefault();
    // call nodemail
    console.log(state);
  }

  return (
    <div>
      <section className="section section-bg" id="call-to-action" style={{ backgroundImage: 'url(/assets/images/book.jpg)' }}>
        <div className="container">
          <div className="row">
            <div className="col-lg-10 offset-lg-1">
              <div className="cta-content">
                <br />
                <br />
                <h2>Feel free to <em>Book us Today!</em></h2>
                <p>Make bookings here, you will recieve a response from in the shortest time possible</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <br />
          <br />
          <div className="row">
            <div className="col-md-8">
              <div className="contact-form">
                <form id="contact" onSubmit={handleSubmit}>
                  <div className="row">

                    <div className="col-md-6 col-sm-12">
                      <fieldset>
                        <input name="date" type="text" id="date" placeholder="31.07.2020" onChange={handleChange} required />
                      </fieldset>
                    </div>

                    <div className="col-md-6 col-sm-12">
                      <fieldset>
                        <input name="time" type="text" id="time" placeholder="20:30" onChange={handleChange} required />
                      </fieldset>
                    </div>

                    <div className="col-md-6 col-sm-12">
                      <fieldset>
                        <input name="number_of_people" type="number" id="number_of_people" placeholder="Number of People" onChange={handleChange} required />
                      </fieldset>
                    </div>

                    <div className="col-md-6 col-sm-12">
                      <fieldset>
                        <input name="email" type="text" id="email" placeholder="Email*" onChange={handleChange} required />
                      </fieldset>
                    </div>

                    <div className="col-lg-12">
                      <fieldset>
                        <textarea name="notes" rows={6} id="notes" placeholder="Notes" onChange={handleChange} required></textarea>
                      </fieldset>
                    </div>
                    <div className="col-lg-12">
                      <fieldset>
                        <button type="submit" id="form-submit" className="main-button">Make A Booking</button>
                      </fieldset>
                    </div>
                  </div>
                </form>
              </div>

              <br />
            </div>

            <div className="col-md-4">
              <div className="tabs-content">
                <label>Email</label>
                <p><a href="mailto:">vip.mobilecoffeebar@gmail.com</a></p>

                <label>Phone</label>
                <p><a href="call:"> +256 785 440728</a></p>

                <label>Address</label>
                <p>110 7th Street Industrial Area</p>
              </div>

              <br />
            </div>
          </div>
        </div>
      </section>
    </div>
  )
};

export default Bookus;
